import type { CameraKeyframe } from "@world/Camera";
import * as THREE from "three";
import { SceneBase } from "./SceneBase";

/**
 * About Scene — placeholder.
 *
 * Currently provides a simple emissive marker so the camera spline has a real
 * second waypoint to travel toward. To be replaced (Stage 3+) with the full
 * About + Chef + Team + Spaces deck migrated from legacy lines 2123-2240 and
 * scene code at 2911-3117.
 */
export class AboutScene extends SceneBase {
  readonly keyframes: CameraKeyframe[] = [
    { position: [3, 1, -2], target: [0, 0, -4], fov: 38 },
    { position: [0, 0.5, -6], target: [0, 0, -10], fov: 42 },
  ];

  readonly range: [number, number] = [0.18, 0.42];

  private marker!: THREE.Mesh;

  constructor() {
    super("about");
  }

  init(): void {
    // Temporary marker — replaced in Stage 3
    const geo = new THREE.IcosahedronGeometry(0.6, 1);
    const mat = new THREE.MeshStandardMaterial({
      color: 0xc9a24b,
      emissive: 0x3a2a0e,
      roughness: 0.4,
      metalness: 0.6,
      flatShading: true,
    });
    this.marker = new THREE.Mesh(geo, mat);
    this.marker.position.set(0, 0, -7);
    this.group.add(this.marker);

    // Soft point light to give the marker form
    const light = new THREE.PointLight(0xe7c277, 1.2, 8, 1.6);
    light.position.set(2, 2, -5);
    this.group.add(light);
  }

  update(deltaSeconds: number, _globalProgress: number, localProgress: number | undefined): void {
    if (localProgress === undefined) return;
    this.marker.rotation.x += deltaSeconds * 0.3;
    this.marker.rotation.y += deltaSeconds * 0.4;
    // Subtle scale-up across the scene
    const s = 0.85 + localProgress * 0.4;
    this.marker.scale.setScalar(s);
  }
}
